import useReloadOnShareExit from '../hooks/useReloadOnShareExit';

const ReloadOnShareExit = () => {
  useReloadOnShareExit();
  return null;
};

export default ReloadOnShareExit;
